import { useState } from 'react';

import {
  colors,
  FormControl,
  OutlinedInput,
  InputAdornment,
  IconButton,
  FormHelperText,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import clsx from 'clsx';
import PropTypes from 'prop-types';

import { Icon } from '@/src/components/atoms';
import { SectionHeader } from '@/src/components/molecules';
import { Section } from '@/src/components/organisms';
import useRDStation from '@/src/lib/rdstation/useRDStation';

const useStyles = makeStyles(theme => ({
  root: {
    background: theme.palette.primary.dark,
    backgroundSize: 'cover',
    borderRadius: theme.spacing(2),
  },
  textWhite: {
    color: 'white',
  },
  inputContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  formControl: {
    maxWidth: 400,
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'white',
      },
      '&:hover fieldset': {
        borderColor: 'white',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'white',
      },
    },
    '& .MuiInputBase-root': {
      color: 'white',
    },
    '& .MuiInputAdornment-root i': {
      color: 'white !important',
    },
  },
}));

const Newsletter = props => {
  const { className, ...rest } = props;

  const classes = useStyles();
  const [input, setInput] = useState('');
  const { message, error, loading, subscribe } = useRDStation();

  const handleSubscribe = () =>
    subscribe({
      email: input,
      conversionIdentifier: 'newsletter',
      campaign: 'career',
      onSuccess: () => setInput(''),
    });

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <Section>
        <>
          <SectionHeader
            title={<span className={classes.textWhite}>Quer receber nossas novidades?</span>}
            subtitle={
              <span className={classes.textWhite}>
                Não perca a chance de receber nossas novidades quando abrir novas vagas ou
                atualizarmos as que estão em aberto.
              </span>
            }
            fadeUp
          />
          <div className={classes.inputContainer}>
            <FormControl
              fullWidth
              error={error}
              disabled={loading}
              variant="outlined"
              data-aos="fade-up"
              className={classes.formControl}>
              <OutlinedInput
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton onClick={handleSubscribe}>
                      <Icon fontIconClass="fas fa-paper-plane" fontIconColor={colors.indigo[900]} />
                    </IconButton>
                  </InputAdornment>
                }
                placeholder="Coloque seu e-mail e aperte 'Enter'"
                value={input}
                onChange={evt => setInput(evt.target.value)}
                onKeyPress={evt => {
                  if (evt.key === 'Enter') {
                    handleSubscribe();
                    evt.preventDefault();
                  }
                }}
              />
              {message && (
                <FormHelperText error={error} className={classes.textWhite}>
                  {message}
                </FormHelperText>
              )}
            </FormControl>
          </div>
        </>
      </Section>
    </div>
  );
};

Newsletter.propTypes = {
  className: PropTypes.string,
};

export default Newsletter;
